import CtxtLink from './CtxtLink'

type Props = {
    children?: React.ReactNode
    className?: string
}

function SupportEmailLink({ className, children }: Props): React.JSX.Element {
    return (
        <CtxtLink to="mailto:support@contxt.network" classes={className}>
            {children ? children : 'support@contxt.network'}
        </CtxtLink>
    )
}

export default SupportEmailLink
